import { Outlet } from "react-router-dom";

const TrendLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default TrendLayout;